<template>
  <div>
    <v-row v-for="(field, index) in inputFieldList" :key="index">
      <v-col
        cols="12"
        sm="10"
        class="pt-2 pb-0 alternate-emails"
        style="position: relative"
      >
        <v-text-field
          :disabled="!isPhotoUploading"
          class="textField"
          v-model.trim="field.value"
          :label="getLable(index)"
          dense
          :rules="!readonly ? alternateEmailRules(field.value) : []"
          @input="updateInputFields"
          filled
          :readonly="readonly || field.isReadonly"
          :clearable="!field.isReadonly || readonly"
          @blur="
            checkEmailExist(field.value, index), setNoneAEAutoSuggest(index)
          "
          :autocomplete="aEAutoSuggest[index] ? aEAutoSuggest[index] : 'none'"
          @focus="setAEAutoSuggest(index)"
        >
          <template v-slot:append>
            <v-fade-transition v-if="field.isDisplay">
              <v-btn outlined x-small color="primaryDark" class="mr-2">
                {{ $t("admin.lblListedInPeople") }}
              </v-btn>
            </v-fade-transition>
          </template>
        </v-text-field>
        <div v-if="isError(field.value)" class="custom-error">
          {{ isError(field.value) ? isError(field.value).error_message : "" }}
        </div>
      </v-col>
      <v-col cols="12" sm="2" class="pt-0 pb-0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="index !== 0"
              v-bind="attrs"
              v-on="on"
              @click="removeInputField(field)"
              icon
              :disabled="readonly || field.isReadonly"
            >
              <v-icon color="primaryDark">mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("admin.removeEmail") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="index === inputLength"
              v-bind="attrs"
              v-on="on"
              @click="addInputField"
              icon
              :disabled="!isPhotoUploading"
            >
              <v-icon color="primaryDark">mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("admin.addAnotherEmail") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <confirm-dialog ref="confirm" />
  </div>
</template>

<script>
import _ from "lodash";
import peopleService from "../../api/peopleService";
import ConfirmDialog from "../ConfirmDialog.vue";

export default {
  name: "RepeatEmailInput",
  props: {
    value: {
      type: Array,
      default: () => [""],
    },
    userEmails: {
      type: Array,
      default: () => [""],
    },
    emailsInAttendees: {
      type: Array,
      default: () => [""],
    },
    userId: {
      type: String,
      default: null,
    },
    mainEmail: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    isPhotoUploading: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      isFieldAdded: false,
      unique_validation: [],
      errorEmails: [],
      aEAutoSuggest: [],
      emailRules: [
        (v) => !!v.trim() || this.$t("ruleEmailReq"),
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t("ruleEmailvalid"),
      ],
    };
  },
  computed: {
    inputFieldList: {
      get() {
        const val = this.value.length == 0 ? [""] : this.value;
        return this.getInputFieldList(val);
      },
      set(value) {
        const values = value.map((field) => field.value);
        this.$emit("input", values);
      },
    },
    inputLength() {
      return this.inputFieldList.length - 1;
    },
  },
  methods: {
    getInputFieldList,
    getUniqueId,
    addInputField,
    removeInputField,
    alternateEmailRules,
    checkInexist,
    checkEmailExist,
    isDisplayEmail,
    isExistInAttendees,
    getLable,
    updateInputFields,
    isError,
    setAEAutoSuggest(index) {
      const result = this.aEAutoSuggest.map((item, inc) => {
        if (inc == index) {
          item = "on";
        }
        return item;
      });
      this.aEAutoSuggest = result;
    },
    setNoneAEAutoSuggest(index) {
      const result = this.aEAutoSuggest.map((item, inc) => {
        if (inc == index) {
          item = "none";
        }
        return item;
      });
      this.aEAutoSuggest = result;
    },
  },
};

function isError(email) {
  const emailId = email ? email : "";
  return this.unique_validation.find(
    (elem) => elem.email.toLowerCase().trim() === emailId.toLowerCase().trim()
  );
}

function updateInputFields(value) {
  if (value && String(value).trim() !== "") {
    this.$emit("isTypingEmail", true);
  }
  const values = this.inputFieldList.map((field) => field.value);
  this.$emit("input", values);
}

function getLable(index) {
  if (index === 0 && this.inputFieldList.length === 1) {
    return this.$t("people.lblAlternateEmail");
  }
  return this.$t("people.lblAlternateEmail") + " " + Number(index + 1);
}

function addInputField() {
  this.isFieldAdded = true;
  this.$emit("newFieldAdded", this.isFieldAdded);
  const values = this.inputFieldList.map((field) => field.value);
  values.push("");
  this.$emit("input", values);
}

function getInputFieldList(values) {
  const list = [];
  const autoSuggest = [];
  values.forEach((value) => {
    let isReadonly = false;
    let isDisplay = false;
    const isDisplayEmail = this.isDisplayEmail(value);
    const existInAttendees = this.isExistInAttendees(value);
    if (isDisplayEmail && this.userId) {
      isReadonly = true;
      isDisplay = true;
    } else if (existInAttendees) {
      isReadonly = true;
      isDisplay = false;
    }

    list.push({
      value,
      id: this.getUniqueId(),
      isReadonly: isReadonly,
      isDisplay: isDisplay,
    });
    autoSuggest.push("none");
  });
  this.aEAutoSuggest = autoSuggest;
  return list;
}

function isExistInAttendees(email) {
  const emailId = String(email).trim();
  if (emailId) {
    return this.emailsInAttendees.includes(emailId.toLowerCase().trim());
  } else {
    return false;
  }
}

function checkInexist(email) {
  const emailId = email ? String(email) : "";
  const user = this.userEmails.find(
    (elem) =>
      elem.registered_email &&
      elem.registered_email.toLowerCase().trim() ===
        emailId.toLowerCase().trim() &&
      elem.id != this.userId
  );
  if (user) {
    return true;
  }
  return false;
}

async function checkEmailExist(email, index) {
  const emailId = email ? email.trim() : "";
  const reEmail =
    /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;

  if (emailId && emailId.length > 0 && emailId.match(reEmail)) {
    const user = this.userEmails.find(
      (elem) =>
        elem.registered_email &&
        elem.registered_email.toLowerCase().trim() ===
          emailId.toLowerCase().trim()
    );
    if (!user) {
      try {
        const uData = await peopleService.check_email(emailId);
        this.$emit("isTypingEmail", false);
        if (uData.data && uData.data.id) {
          this.errorEmails.push({
            index: index,
            email: emailId,
            field: this.inputFieldList[index],
          });
          const validate = {
            email: emailId,
            isError: true,
            error_message: this.$t("admin.msgAltEmailUnique"),
            errorEmails: this.errorEmails,
          };
          this.unique_validation.push(validate);
          this.$eventHub.$emit("onCheckEmailAttendeesError", validate);
        } else {
          this.errorEmails = this.errorEmails.filter(function (item) {
            return item.index !== index;
          });
          this.$eventHub.$emit("onCheckEmailAttendeesError", {
            errorEmails: this.errorEmails,
          });
        }
      } catch (error) {
        console.log(error, "repeat email")
      }
    }
  }
}

function isDisplayEmail(email) {
  const emailId = email ? String(email) : "";
  const user = this.userEmails.find(
    (elem) =>
      elem.people_display_email &&
      elem.people_display_email.toLowerCase().trim() ===
        emailId.toLowerCase().trim()
  );
  if (user && user.id == this.userId) {
    return true;
  }
  return false;
}

function removeInputField(field) {
  this.inputFieldList = _.remove(this.inputFieldList, (n) => n.id !== field.id);
  this.$emit("isTypingEmail", false);
}

function getUniqueId() {
  return `_${Math.random().toString(36).substr(2, 9)}`;
}

function alternateEmailRules(value) {
  const email = value ? String(value).trim() : "";
  if (email == "" || email == null) {
    return [true];
  }

  if (email.length > 70) {
    return [this.$t("ruleEmailMaxLength")];
  }

  const reEmail =
    /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
  if (!email.match(reEmail)) {
    return [this.$t("ruleEmailvalid")];
  }

  const cloneEmailIds = _.cloneDeep(_.compact(this.value));
  const indexOf = cloneEmailIds.indexOf(value);
  if (indexOf > -1) {
    cloneEmailIds.splice(indexOf, 1);
  }
  const isExist = cloneEmailIds.some(
    (s) => String(s).toLowerCase() === String(value).toLowerCase()
  );
  if (
    isExist ||
    String(this.mainEmail).toLowerCase() === String(value).toLowerCase()
  ) {
    return [this.$t("admin.msgEmailUnique")];
  }
  const user = this.userEmails.find(
    (elem) =>
      elem.registered_email &&
      elem.registered_email.toLowerCase().trim() ===
        email.toLowerCase().trim() &&
      elem.id != this.userId
  );

  if (user) {
    return [this.$t("admin.msgEmailUnique")];
  }

  return [true];
}
</script>

<style scoped>
.textField {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  max-height: 68px !important;
  color: var(--v-neutralGray-base) !important;
  align-items: center !important;
}
.textField > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
  height: 48px !important;
}
.textField /deep/ .v-input__slot {
  min-height: 52px !important;
}
.custom-error {
  color: var(--v-error-base);
  margin-top: -15px;
  margin-bottom: 10px;
}
.alternate-emails:has(.custom-error)
  /deep/
  .v-text-field__details
  .error--text {
  display: none;
}
</style>
